/*
 * @Author: czj
 * @Date: 2025-03-28 15:55:58
 * @Description: 
 * @FilePath: \test-demo2\src\api\index.js
 */
import request from '@/utils/request';
import { useStore } from '@/Store/index.js';
import { ElMessage } from 'element-plus';



//默认GET请求
export function get_request(url, params) {
  return request({
    url,
    method: 'get',
    params
  });
};

//默认POST请求
export function post_request(url, data) {
  return request({
    url,
    method: 'post',
    data
  });
};


//文件流
export function defaultFullRequestMethodGet(url, params) {
  // 将参数对象转换为查询字符串
  const queryString = new URLSearchParams(params).toString();
  const fullUrl = queryString ? `${url}?${queryString}` : url;
  const store = useStore();
  return fetch(fullUrl, {
    method: 'GET',
    headers: {
      'Ticket': store.ticket || null
    }
  }).then(response => {
    if (!response.ok) {
      // throw new Error(`HTTP error! Status: ${response.status}`);
      // 如果 response 不是 ok, 尝试从 response 中解析错误信息
      return response.json().then(errData => {
        throw new Error(errData.message || `HTTP error! Status: ${response.status}`);
      });
    }
    // 返回 `blob` 或者 `arrayBuffer` 根据需要进行选择
    return response.blob();
    // return response.arrayBuffer();
  }).catch(error => {
    console.error('Fetch error:', error);
    // 如果 error 是 JSON 解析出来的
    const errorMessage = error.message || '请求出错';
    // 显示消息框
    ElMessage.error(errorMessage);
    throw error;
  });
};



//获取模板配置
export function get_template_config(data) {
  return request({
    url: '/genostack/get_template_config',
    method: 'post',
    data
  });
};


//获取报告数据
export function get_report_data(data) {
  return request({
    url: '/flow/get_report_data',
    method: 'post',
    data
  });
};

//报告生成
export function generate_report(data) {
  return request({
    url: '/flow/download_or_save_report',
    method: 'post',
    data
  });
};

//获取文件数据
export function get_file_data(data) {
  data.callback_function = {
    ...data.callback_function,
    separator: 'auto_by_suffix'
  };
  return request({
    url: '/genostack/read_file',
    method: 'post',
    data
  });
};

//写入文件数据
export function write_file_data(data) {
  return request({
    url: '/genostack/rewrite_file',
    method: 'post',
    data
  });
};

//获取合约数据
export function get_contract_data(data) {
  return request({
    url: '/genostack/get_contract_data',
    method: 'post',
    data
  });
};

//获取项目列表
export function get_project_list(data) {
  return request({
    url: '/genostack/get_project_list',
    method: 'post',
    data
  });
};

//获取项目目录
export function get_project_dir(data) {
  return request({
    url: '/genostack/get_project_dir',
    method: 'post',
    data
  });
};

//获取项目文件
export function get_project_file(data) {
  return request({
    url: '/genostack/get_project_file',
    method: 'post',
    data
  });
};

//获取任务列表
export function get_task_list(data) {
  return request({
    url: '/genostack/get_task_list',
    method: 'post',
    data
  });
};

//获取数据中心数据
export function get_data_center_data(data) {
  return request({
    url: '/genostack/get_data_center_data',
    method: 'post',
    data
  });
};

//获取任务目录
export function get_task_dir(data) {
  return request({
    url: '/genostack/get_task_dir',
    method: 'post',
    data
  });
};

// 获取单个任务节点结果
export function get_report_task_list(data) {
  return request({
    url: '/flow/get_report_task_list',
    method: 'get',
    params: data
  });
};

//启动单节点
export function start_task(data) {
  return request({
    url: '/flow/start_task',
    method: 'post',
    data
  });
};

//获取节点历史数据
export function get_node_history_data(data) {
  return request({
    url: '/flow/get_report_task_data',
    method: 'post',
    data
  });
};

//获取关联节点列表
export function get_associated_nodes_list(data) {
  return request({
    url: '/flow/get_associated_nodes_list',
    method: 'post',
    data
  });
};

//获取任务列表全部
export function get_task_list_all(params) {
  return request({
    url: '/flow/get_report_task_list_all',
    method: 'get',
    params
  });
};


/**
 * 获取表单数据接口
 * @remarks 该接口用于获取表单数据，这是三黍新增的需求接口
 * 日期：2025-08-26
 */
export function get_flow_input_form(appId, taskId) {
  return request({
    url: `/flow/get_flow_input_form/${appId}`,
    method: 'get',
    params: { task_id: taskId }
  });
};


//上传文件
export function upload_file(data) {
  return request({
    method: 'POST',
    url: `/genostack/upload_file`,
    data
  })
}



//设计差异分析方案-文件生成
export function generate_design_difference_analysis_file() {
  return request({
    url: '/flow/design_difference_analysis_plan_file_generate',
    method: 'get'
  });
};

/* //导出方案
export function export_plan(data) {
  return request({
    url: '/flow/export_plan',
    method: 'post',
    data
  });
} */

// api/index.js
// 导出方案
export function export_plan(data) {
  return request({
    url: '/flow/export_plan',
    method: 'post',
    data,
    responseType: 'blob' // 必须加这个，告诉 Axios 返回二进制流
  });
}



//分组信息文件设置-上传
//group_info_settings_file_upload 文件上传, POST maps,filepath , 文件流 file

export function upload_group_file(data) {
  return request({
    url: '/flow/group_info_settings_file_upload',
    method: 'post',
    data
  });
};


/**
 * 分组信息文件设置-下载
 * @remarks 该接口用于 下载分组文件
 * 日期：2025-08-26
 */
export function download_group_file(data) {
  return request({
    url: '/flow/group_info_settings_file_download',
    method: 'post',
    data
  });
};


//三黍
//保存报告配置
export function save_report_config(data) {
  return request({
    url: '/flow/set_task_report_config',
    method: 'post',
    data
  });
};



//获取剩余重分析次数
export function get_remaining_reanalysis_times(params) {
  return request({
    url: '/flow/get_reanalysis_num',
    method: 'get',
    params
  });
};


//获取颜色组的接口
export function get_color_group() {
  return request({
    method: 'get',
    url: `/genostack/custom_color_palettes`
  })
}